import React, { Component } from 'react'
import ErrorView from '../ErrorView'
import { HLJ_STATISTIC, getMerchantInfo, sendEnrichDataToSentry } from '@util'
import isEmpty from 'lodash/isEmpty'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }
  componentDidCatch(error, info) {
    if (error && info) {
      const ext = {
        error: error.toString(),
        info: JSON.stringify(info),
        url: window.location.href,
        hasMerchantInfo: !isEmpty(getMerchantInfo())
      }

      if (window.navigator && window.navigator.onLine !== undefined) {
        ext.online = window.navigator.onLine ? 'online' : 'offline'
      }
      HLJ_STATISTIC({
        element_tag: 'componentDidCatch',
        event_type: 'local_merchant_error_catch',
        ext
      })
      sendEnrichDataToSentry(error)
    }
    this.setState({ hasError: true })
  }

  render() {
    return this.state.hasError ? (
      <ErrorView title="抱歉...婚礼纪开小差啦..." />
    ) : (
      this.props.children
    )
  }
}
